module.exports = __webpack_public_path__ + "Excel.0ec1668c9ed3c038b5c1faec987bfb67.png";